import { Fragment } from 'react';
import { Button } from '../../components/Button';
import { FormCard } from '../../components/FormCard';
import { FormField } from '../../components/FormField';
import { TextInput } from '../../components/FormField/FormField.styles';
import { TextArea } from '../../components/TextArea';
import {
  ButtonGroup,
  FreeTextWrapper,
  LabelText,
  OtherInputWrapper,
  Panel,
  PreferencesSection,
} from './PreferencesPanel.styles';
import type { PreferencesPanelProps } from './PreferencesPanel.types';

export function PreferencesPanel({
  categories,
  onOptionToggle,
  onOtherChange,
  onFreeTextChange,
  otherButtonLabel = 'Other',
}: PreferencesPanelProps) {
  return (
    <Panel>
      <>
        {categories.map((category) => {
          const isOtherSelected = category.selectedOptions?.includes(otherButtonLabel);

          if (category.isFreeText || !category.options || category.options.length === 0) {
            return (
              <PreferencesSection key={category.id} $noBorder>
                <LabelText>{category.label}</LabelText>
                <FreeTextWrapper>
                  <FormCard>
                    <FormField label={category.otherLabel || category.label}>
                      <TextArea
                        placeholder={category.freeTextPlaceholder}
                        value={category.freeTextValue || ''}
                        onChange={(e) => onFreeTextChange(category.id, e.target.value)}
                      />
                    </FormField>
                  </FormCard>
                </FreeTextWrapper>
              </PreferencesSection>
            );
          }

          return (
            <Fragment key={category.id}>
              {category.options && (
                <PreferencesSection>
                  <LabelText>{category.label}</LabelText>
                  <ButtonGroup>
                    {category.options.map((option) => (
                      <Button
                        key={option}
                        variant="toggle"
                        size="small"
                        selected={category.selectedOptions?.includes(option)}
                        onClick={() => onOptionToggle(category.id, option)}
                        type="button"
                      >
                        {option}
                      </Button>
                    ))}
                    {!category.options.includes(otherButtonLabel) && (
                      <Button
                        variant="toggle"
                        size="small"
                        selected={isOtherSelected}
                        onClick={() => onOptionToggle(category.id, otherButtonLabel)}
                        type="button"
                      >
                        {otherButtonLabel}
                      </Button>
                    )}
                  </ButtonGroup>
                </PreferencesSection>
              )}
              {isOtherSelected && (
                <OtherInputWrapper>
                  <FormCard>
                    <FormField label={category.otherLabel || category.label}>
                      <TextInput
                        value={category.otherValue || ''}
                        onChange={(e) => onOtherChange(category.id, e.target.value)}
                      />
                    </FormField>
                  </FormCard>
                </OtherInputWrapper>
              )}
            </Fragment>
          );
        })}
      </>
    </Panel>
  );
}
